module.exports = __webpack_public_path__ + "img/page.f7e3d7b6.png";